import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import { SideMenuBoxRecoil, passwordModifyModalRecoil } from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import { UserApi } from '@/sdk/UserApi';
import { userInforRecoil } from '@/atom/UserAtom';
import PasswordModifyModal from '@/modal/PasswordModifyModal';
import {
  activeIndexRecoil,
  activeSubIndexRecoil,
  openMenuIndexRecoil,
} from '@/atom/MenuAtom';

const Header = () => {
  const userApi = new UserApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const [sideMenuBoxState, setSideMenuBoxState] =
    useRecoilState(SideMenuBoxRecoil);
  const [passwordModifyState, setPasswordModifyState] = useRecoilState(
    passwordModifyModalRecoil,
  );
  const [userInforState, setUserInforState] = useRecoilState(userInforRecoil);
  const [activeIndex, setActiveIndex] = useRecoilState(activeIndexRecoil);
  const [activeSubIndex, setActiveSubIndex] =
    useRecoilState(activeSubIndexRecoil);
  const [openMenuIndex, setOpenMenuIndex] = useRecoilState(openMenuIndexRecoil);

  const fetchUserInfor = async () => {
    try {
      const { data } = await userApi.userControllerMenu({
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setUserInforState(data);
    } catch (err: any) {
      console.log(err);
    }
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/login');
  };

  const handleLogoClick = () => {
    navigate('/dashboard');
    setActiveIndex(0);
    setOpenMenuIndex(null);
    setActiveSubIndex(null);
    sessionStorage.setItem('activeIndex', String(0));
    sessionStorage.removeItem('activeSubIndex');
    sessionStorage.removeItem('openMenuIndex');
  };

  useEffect(() => {
    fetchUserInfor();
  }, []);

  return (
    <>
      <Wrap className="flex aic jce">
        <button className="logo-box" onClick={handleLogoClick}>
          <h1>노후건축물 안전진단 플랫폼</h1>
        </button>
        <Box className="flex aic">
          <span className="text tm">{userInforState?.name}님</span>
          <span className="line"></span>
          <button
            className="text tm"
            type="button"
            onClick={() => setPasswordModifyState(true)}
          >
            정보변경
          </button>
          <span className="line"></span>
          <button className="text tm" type="button" onClick={handleLogout}>
            로그아웃
          </button>
          <button
            className="ham-btn img-box"
            type="button"
            onClick={() => setSideMenuBoxState(true)}
          >
            <img src="/img/ico_ham_444.svg" alt="" />
          </button>
        </Box>
      </Wrap>
      {passwordModifyState && <PasswordModifyModal />}
    </>
  );
};

export default Header;

const Wrap = styled.div`
  width: 100%;
  height: 72px;
  box-sizing: border-box;
  padding: 0 56px;
  border-bottom: 1px solid #eeeeff;
  > .logo-box {
    display: none;
  }
  @media (max-width: 1420px) {
    justify-content: space-between;
    height: 60px;
    padding: 0 20px;
    .logo-box {
      display: block;
      > h1 {
        color: #4880ff;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
`;

const Box = styled.div`
  gap: 16px;
  .text {
    color: #444;
    font-size: 14px;
  }
  .line {
    width: 1px;
    height: 12px;
    background: #e9e8e8;
  }
  .btn {
    font-size: 14px;
    color: #444;
  }
  .ham-btn {
    display: none;
  }
  @media (max-width: 1420px) {
    .ham-btn {
      display: block;
      width: 20px;
      margin-left: 12px;
    }
  }
`;
